import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  QueryList,
  SimpleChanges,
  ViewChildren
} from '@angular/core';
import {
  ScoreDevelopmentChipVm,
  ScoreDevelopmentVm,
  StatementResponsesVm,
  StatementsVm,
  StatementVm
} from '../../models/team-dynamic.vm';
import {TeamIndicatorRowVm} from '../../models/team-dynamic-team.vm';
import {StatementFilters} from '../statements/statements.component';

@Component({
  selector: 'app-team-indicators',
  templateUrl: './team-indicators.component.html',
  styleUrls: ['./team-indicators.component.scss']
})
export class TeamIndicatorsComponent implements OnChanges {
  private static readonly SCROLL_DELAY_MS = 350;

  @Input() rows: TeamIndicatorRowVm[] = [];
  @Input() openUuid: string | null = null;
  @Input() scores: ScoreDevelopmentVm = {labels: [], values: []};
  @Input() loadingScores: boolean = false;
  @Input() statements: StatementsVm | null = null;
  @Input() loadingStatements: boolean = false;
  @Input() statementResponses: StatementResponsesVm | null = null;

  @Output() opened = new EventEmitter<TeamIndicatorRowVm>();
  @Output() closed = new EventEmitter<void>();
  @Output() statementFiltersChanged = new EventEmitter<StatementFilters>();
  @Output() statementOpened = new EventEmitter<StatementVm>();

  @ViewChildren('indicatorRow') indicatorRows: QueryList<ElementRef> | undefined;

  selectedTabs: boolean[] = [];
  chartChips: ScoreDevelopmentChipVm[] = [];
  indicatorCharts: any[] = [];

  chartOptions = {
    plugins: {
      tooltip: {
        enabled: false
      }
    },
    elements: {
      arc: {
        borderColor: '#E6E6E6',
        borderWidth: 3
      }
    }
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['rows']) {
      this.setIndicatorCharts();
    }
    if (changes['rows'] || changes['openUuid']) {
      this.syncOpenRow();
    }
  }

  scrollToIndicator(uuid: string) {
    setTimeout(() => {
      const index = (this.rows ?? []).findIndex(row => row.uuid === uuid);
      this.indicatorRows?.toArray()[index]?.nativeElement
        ?.scrollIntoView({behavior: 'smooth', block: 'start'});
    }, TeamIndicatorsComponent.SCROLL_DELAY_MS);
  }

  onRowOpen(row: TeamIndicatorRowVm) {
    this.opened.emit(row);
  }

  onRowClose(row: TeamIndicatorRowVm) {
    if (this.openUuid !== row.uuid) {
      return;
    }
    this.closed.emit();
  }

  onStatementFiltersChanged(filters: StatementFilters) {
    this.statementFiltersChanged.emit(filters);
  }

  onStatementOpened(statement: StatementVm) {
    this.statementOpened.emit(statement);
  }

  trackByUuid(index: number, row: TeamIndicatorRowVm) {
    return row.uuid ?? index;
  }

  private syncOpenRow() {
    const rows = this.rows ?? [];
    const openIndex = rows.findIndex(row => row.uuid === this.openUuid);
    this.selectedTabs = rows.map((row, index) => index === openIndex);
    this.chartChips = openIndex === -1 ? [] : [{
      uuid: rows[openIndex].uuid,
      title: rows[openIndex].title,
      icon: rows[openIndex].icon,
      color: rows[openIndex].color
    }];
  }

  private setIndicatorCharts() {
    this.indicatorCharts = (this.rows ?? []).map(row => ({
      datasets: [{
        data: [row.score, 100 - row.score],
        backgroundColor: [row.color, '#E6E6E6']
      }]
    }));
  }
}
